import React from 'react';
import { OwnPropsOfRenderer, UISchemaElement } from '@jsonforms/core';
import { Col, Row } from 'antd';
import { isEmpty } from 'lodash';
import { RenderLayoutElements } from '@components/uploadForm/renderers/views/layouts/layout';
import { twMerge } from '@utils/twMerge';

interface LayoutRendererProps extends OwnPropsOfRenderer {
  elements: UISchemaElement[];
  direction: 'row' | 'column';
  className?: string;
}

export const LayoutRenderer: React.FC<LayoutRendererProps> = ({
  elements,
  schema,
  path,
  enabled,
  direction,
  renderers,
  cells,
  className
}: LayoutRendererProps) => {
  const GridContainer = direction === 'row' ? Row : Col;
  const containerProps: React.HTMLAttributes<HTMLDivElement> &
    React.CSSProperties & { gutter?: number } = {};

  if (direction === 'row') {
    containerProps.gutter = 2;
    containerProps.style = { gap: '16px' };
  }
  if (isEmpty(elements)) {
    return null;
  } else {
    return (
      <GridContainer {...containerProps} className={twMerge('w-full', className)}>
        <RenderLayoutElements
          elements={elements}
          schema={schema!}
          path={path!}
          enabled={enabled!}
          direction={direction}
          renderers={renderers}
          cells={cells}
        />
      </GridContainer>
    );
  }
};
